import React, {Component} from "react";
import {Button, DatePicker, Form, Select, Typography} from "antd";
import dayjs from "dayjs";
import PropTypes from 'prop-types';

import {ucFirst} from "../helpers/misc";

import {formItemSubmitButtonStyle, formStandaloneLayout} from "../assets/styles";

class StatusForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: this.props.defaultStatus,
            startedAt: undefined,
            endedAt: undefined,
            type: this.props.type,
            tempStatus: false,
        };
        this.formRef = React.createRef();
    }

    onDateChange = (date, dateString) => {
        let startedAt = null;
        let endedAt = null;

        if (Array.isArray(date)) {
            // both start time and end time
            if (date.length === 2) {
                startedAt = date[0];
                endedAt = date[1];
            }
        } else if (date instanceof dayjs) {
            // start time only
            startedAt = date;
            endedAt = null;
        }
        this.setState({
            startedAt: startedAt,
            endedAt: endedAt,
        });
    };

    onStatusChange = (status) => {
        this.setState({status});
    };

    // Comment out until temp status is supported in the backend
    // onTempStatusChange = (e) => {
    //     this.setState({tempStatus: e.target.checked});
    // };

    handleFinish = async (values) => {
        this.props.handleFinish(this.state);
    };

    render() {
        const datePickerProps = {
            showTime: {minuteStep: 15, use12Hours: true, format: "hh:mm A"},
            format: "YYYY-MM-DD hh:mm A",
            onOk: this.onDateChange,
            placeholder: "Start Date Time",
        };
        const rangePickerProps = {
            ...datePickerProps,
            placeholder: ["Start Date Time", "End Date Time"],
        };

        const {tempStatus, defaultStatus} = this.state;
        const {status, buttonText} = this.props;

        return (
            <Form
                {...formStandaloneLayout}
                ref={this.formRef}
                name="status"
                onFinish={this.handleFinish}
                initialValues={{
                    // 'Temporary Status': tempStatus,
                    'Status': defaultStatus,
                }}
            >
                <Form.Item wrapperCol={{
                    sm: {span: 16, offset: 3},
                }}>
                    <Typography.Title level={3}>Update Status</Typography.Title>
                </Form.Item>
                {/*Uncomment once temp status is complete on backend*/}
                {/*<Form.Item*/}
                {/*    name="Temporary Status"*/}
                {/*    label="Temporary Status"*/}
                {/*    rules={[{type: 'boolean'}]}*/}
                {/*>*/}
                {/*    <Checkbox onChange={this.onTempStatusChange}/>*/}
                {/*</Form.Item>*/}
                <Form.Item
                    name="Status"
                    label="Status"
                    rules={[{type: 'string', required: true}]}
                >
                    <Select style={{width: 150}} onChange={this.onStatusChange}>
                        {
                            status && status.map(
                                (status, index) =>
                                    <Select.Option value={status} key={index}>{ucFirst(status)}</Select.Option>
                            )
                        }
                    </Select>
                </Form.Item>
                {
                    tempStatus
                        ?
                        <Form.Item
                            name="Time Range"
                            label="Time Range"
                            rules={[{type: 'array', required: true}]}
                        >
                            <DatePicker.RangePicker
                                {...rangePickerProps}
                                style={{'minWidth': '400px'}}
                            />
                        </Form.Item>
                        :
                        <Form.Item
                            name="Start Time"
                            label="Start Time"
                            rules={[{type: 'object', required: true}]}
                        >
                            <DatePicker
                                {...datePickerProps}
                            />
                        </Form.Item>
                }
                <Form.Item {...formItemSubmitButtonStyle}>
                    <Button htmlType="submit">{buttonText}</Button>
                </Form.Item>
            </Form>
        )
    }
}

export default StatusForm;

StatusForm.propTypes = {
    defaultStatus: PropTypes.string.isRequired,
    status: PropTypes.array.isRequired,
    handleFinish: PropTypes.func.isRequired,
};
